'use client';
import React, { useState } from 'react';
import Hero from '@/app/locations/hero';
import Local from '@/app/locations/alllocations';
import AllCities from '../data/all-state/all-cities.json';
import TawkTo from '../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  const [filteredCities, setFilteredCities] = useState(AllCities);

  // Callback function to handle search
  const handleSearch = (searchTerm) => {
    const filtered = AllCities.filter((cities) =>
      cities.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCities(filtered);
  };
  return (
    <div>
      <title>Explore the Cities of the States with Prestige Ride</title>
      <meta
        name="description"
        content="Plan your next trip to the cities across the United States with Prestige Ride. Travel to the best city in the state with our luxury black car services."
      />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content="" />
      <link rel="canonical" href="https://www.prestigeride.com/locations" />
      <TawkTo />
      <Navbar />
      <Hero onSearch={handleSearch} />
      <Local filteredCities={filteredCities} />
      <Footer />
    </div>
  );
}

export default page;
